// extracted by mini-css-extract-plugin
module.exports = {"container":"RecipeXSellCategory_container__3S1Ol","title":"RecipeXSellCategory_title__HsWQ5"};